import { schema } from 'normalizr';

export const appointmentReasonSchema = new schema.Entity('appointmentReasons');
export const appointmentReasonsListSchema = new schema.Array(appointmentReasonSchema)
